<mat-tab-group [@.disabled]="true" (selectedTabChange)="tabChanged($event)" id="appLogs">
    <div *ngFor="let item of logData">
        <mat-tab *ngIf="item.visible.value" [label]="item.title">
            <div class="font-weight-bold text-center">{{item.text}}</div>
            <pre *ngIf="item.logs">{{item.logs}}</pre>
            <div *ngIf="item.html" [innerHTML]="item.html"></div>
        </mat-tab>
    </div>
</mat-tab-group>
